// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tile":"_1AyKtG","comingSoon":"_1xgSFv","iconContainer":"HwtJue","textWrapper":"_10TBvv","comingSoonText":"_1YOPIe"};